import { fieldTypes, type FieldDef, type FieldOption } from "../lib/workspace";

export const blankField = (): FieldDef => ({ key: "", label_en: "", label_ar: "", type: "text", options: [], ai_fillable: false });

const hasChoices = (t: string) => t === "select" || t === "multi_select";

// FieldEditor edits one field definition. For a saved field the type and
// key are fixed and existing choices can be renamed but not removed.
export function FieldEditor({ value: d, onChange, saved, keepValues = [] }: {
  value: FieldDef;
  onChange: (d: FieldDef) => void;
  saved?: boolean;
  keepValues?: string[];
}) {
  const set = (patch: Partial<FieldDef>) => onChange({ ...d, ...patch });
  const setOption = (i: number, patch: Partial<FieldOption>) => set({ options: d.options.map((o, j) => (j === i ? { ...o, ...patch } : o)) });
  return (
    <div className="field-editor">
      <div className="row">
        <label className="field"><span>Name (English)</span><input value={d.label_en} maxLength={60} required onChange={(e) => set({ label_en: e.target.value })} placeholder="e.g. Ticket size" /></label>
        <label className="field"><span>Name (Arabic)</span><input dir="rtl" value={d.label_ar} maxLength={60} onChange={(e) => set({ label_ar: e.target.value })} placeholder="مثال: حجم الاستثمار" /></label>
        <label className="field"><span>Type</span>
          <select value={d.type} disabled={saved} onChange={(e) => set({ type: e.target.value as FieldDef["type"], options: hasChoices(e.target.value) && d.options.length === 0 ? [{ value: "", label_en: "", label_ar: "" }] : d.options })}>
            {fieldTypes.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </label>
      </div>
      {hasChoices(d.type) && (
        <div className="field">
          <span>Choices</span>
          {d.options.map((o, i) => (
            <div key={i} className="option-row">
              <input aria-label={`Choice ${i + 1} (English)`} value={o.label_en} maxLength={80} placeholder="English" onChange={(e) => setOption(i, { label_en: e.target.value })} />
              <input aria-label={`Choice ${i + 1} (Arabic)`} dir="rtl" value={o.label_ar} maxLength={80} placeholder="العربية" onChange={(e) => setOption(i, { label_ar: e.target.value })} />
              {keepValues.includes(o.value) ? <span className="muted small" title="Saved choices can be renamed but not removed, so existing records keep their value">kept</span> : (
                <button type="button" className="link small" onClick={() => set({ options: d.options.filter((_, j) => j !== i) })}>Remove</button>
              )}
            </div>
          ))}
          <button type="button" className="link small" onClick={() => set({ options: [...d.options, { value: "", label_en: "", label_ar: "" }] })}>Add a choice</button>
        </div>
      )}
      <label className="inline small">
        <input type="checkbox" checked={d.ai_fillable} onChange={(e) => set({ ai_fillable: e.target.checked })} />
        The AI assistant may fill this in when a customer mentions it
      </label>
    </div>
  );
}
